import React from 'react'
import { Col, Row } from 'reactstrap'

import './styles.scss'
import SidePopupHelp from '../../../../components/SidePopupHelp'
import { lang } from 'utils/helpers'

function PanelHelpOverView(props) {
  const { onHide } = props

  return (
    <SidePopupHelp onHide={onHide} className='panel-right-info'>
      <Row>
        <Col xs='12'>
          <h1 className='panel-title'>{lang('dashboard_main-panel')}</h1>
        </Col>
      </Row>

      <Row>
        <Col xs='12'>
          <p className='panel-desciption'>{lang('dashboard_overview-help-panel-todo-list')}</p>
        </Col>
      </Row>

      <Row className='panel-section'>
        <Col>
          <h4 className='panel-subtitle'>{lang('dashboard_overview-help-panel-how-nixi1-work')}</h4>
          <div className='panel-card-video'></div>
        </Col>
      </Row>

      <Row className='panel-section'>
        <Col>
          <h4 className='panel-subtitle'>{lang('dashboard_overview-help-panel-what-channels')}</h4>
          <p className='panel-text'>{lang('dashboard_overview-help-panel-channels-description')}</p>
        </Col>
      </Row>

      <Row className='panel-section'>
        <Col>
          <h4 className='panel-subtitle'>{lang('dashboard_payment-providers')}</h4>
          <p className='panel-text'>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt.</p>
        </Col>
      </Row>

      <div className='panel-section-download'>
        <img className='panel-ic' src='img/icon-manual.svg' alt="manual" />
        <a className='panel-link' href='www.google.com'>{lang('dashboard_see-manual')} ({lang('dashboard_pdf')})</a>
      </div>
    </SidePopupHelp>
  )
}

export default PanelHelpOverView
